import React from "react";

export default function Contact() {
  return (
    <main className="pt-24 pb-16 px-6 max-w-5xl mx-auto text-gray-700 leading-relaxed">
      <h1 className="text-3xl font-bold text-center mb-8">Contact Us</h1>

      <section className="mb-8">
        <h2 className="text-lg font-semibold mb-2 text-gray-900">St. Stephen's Church</h2>
        <address className="not-italic text-gray-700">
          1, L. Jagmohandas Marg, Cumballa Hill,<br />
          Mumbai 400036
        </address>
      </section>

      <section className="mb-8">
        <h3 className="text-lg font-semibold mb-2 text-gray-900">Contact</h3>
        <p className="mb-2">
          <strong>Phone:</strong>{" "}
          <a href="tel:+912235634667" className="text-amber-700 hover:underline">
            +91 22 35634667
          </a>{" "}
          <span className="text-gray-600">— call only between 10 AM - 1 PM (Mon - Sat)</span>
        </p>

        <p>
          <strong>Email:</strong>{" "}
          <a href="mailto:ststephen1941@gmail.com" className="text-amber-700 hover:underline">
            ststephen1941@gmail.com
          </a>
        </p>
      </section>

      <section>
        <h3 className="text-lg font-semibold mb-2 text-gray-900">Parish Office Hours</h3>
        <p className="text-gray-700">
          The Parish Office accepts enquiries and calls between <strong>10:00 AM – 1:00 PM</strong>, Monday to Saturday.
        </p>
      </section>
    </main>
  );
}
